import React, { useState } from 'react';

interface FAQItem {
  question: string;
  answer: string;
}

const FAQ: React.FC = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqs: FAQItem[] = [
    {
      question: 'Hvordan fungerer Stempz?',
      answer:
        'Stempz er en digital lojalitetskort-app. Last ned appen, finn Stempz stedet du vil besøke, og skann enkelt QR koden hos dem. Når kortet for Stempz stedet er fullt nyter du en gratis belønning eller en rabatt.',
    },
    {
      question: 'Hva er en deal?',
      answer:
        'En deal er et tilbud fra et Stempz-sted, for eksempel 2 for 1 eller 20 % på bakst. Du ser hvor mange ganger du kan bruke den, aktiverer den i appen og viser skjermen i kassen. Brukte deals ligger under Brukt.',
    },
    {
      question: 'Koster det noe å bruke Stempz?',
      answer:
        'Nei, Stempz er helt gratis å laste ned og bruke. Det er ingen skjulte avgifter eller abonnementer.',
    },
    {
      question: 'Hva hvis jeg bytter telefon?',
      answer:
        'Stempz-kontoen din er knyttet til telefonnummeret ditt. Last bare ned appen på den nye telefonen og logg inn med samme nummer. Alle kortene og stemplene dine vil være der!',
    },
    {
      question: 'Hvilke steder støtter Stempz?',
      answer:
        'Du kan finne alle Stempz steder i appen. Vi legger stadig til nye steder. Dersom din favorittkafè eller frisør enda ikke er på listen, be de ta kontakt med oss!',
    },
    {
      question: 'Hvordan blir jeg en Stempz partner?',
      answer:
        'Bedrifter som ønsker å tilby sine kunder Stempz kan enkelt registere seg gjennom vår bedriftsside. Vi hjelper deg fra A-Å og sørger for en smidig igangsettelse. Kontakt oss på hello@stempz.no for mer informasjon.',
    },
    {
      question: 'Hvordan håndteres dataene mine?',
      answer:
        'Vi tar personvernet ditt på alvor. Dine data er kryptert og lagret sikkert. Vi deler aldri din personlige informasjon med tredjeparter. Du kan lese mer i vår personvernpolicy.',
    },
    {
      question: 'Kan jeg bruke Stempz offline?',
      answer:
        'Ja! Lojalitetskortene dine lagres lokalt på enheten din, så du kan se dem og bruke dine kort selv uten internettforbindelse. Stempz synkroniseres når du er tilbake online.',
    },
    {
      question: 'Hva skjer hvis jeg mister telefonen?',
      answer:
        'Siden kontoen din er knyttet til telefonnummeret ditt, kan du bare logge inn på en ny enhet med samme nummer. Alle kortene og fremgangen din vil bli gjenopprettet.',
    },
  ];

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section
      id="faq"
      className="py-20 bg-gradient-to-b from-white to-teal-50"
    >
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
              Ofte stilte spørsmål
            </h2>
            <p className="text-xl text-gray-600">
              Alt du trenger å vite om Stempz
            </p>
          </div>

          <div className="space-y-4">
            {faqs.map((faq, index) => (
              <div
                key={index}
                className="bg-white rounded-2xl shadow-lg border border-teal-100 overflow-hidden"
              >
                <button
                  onClick={() => toggleFAQ(index)}
                  className="w-full px-6 py-5 text-left flex items-center justify-between hover:bg-teal-50 transition-colors"
                >
                  <span className="font-semibold text-gray-900 text-lg pr-8">
                    {faq.question}
                  </span>
                  <svg
                    className={`w-6 h-6 text-teal-600 flex-shrink-0 transition-transform ${openIndex === index ? 'transform rotate-180' : ''
                      }`}
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M19 9l-7 7-7-7"
                    />
                  </svg>
                </button>
                {openIndex === index && (
                  <div className="px-6 pb-5">
                    <p className="text-gray-600 leading-relaxed">
                      {faq.answer}
                    </p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQ;

